import React from 'react'
import BarChart from './barChart';
import { getBalancesChartData } from './api';
import numberFormatter from 'src/utils/numberFormatter';
import { numberFormat } from 'highcharts';
const chartProps = {
    type: "column",
    backgroundColor: "Transparent",
    height: 400,
    marginBottom: 100,
    marginTop: 30,
    style: {
        fontFamily: "Segoe UI",
    }
};
const otherOptions = {
    title: {
        text: ''
    },
    tooltip: {
        formatter: function () {
            const { number: value, suffix = '' } = numberFormatter(this.y)
            return `<b>$${numberFormat(value, 2, '.', ',')}${suffix}</b>`;
        }
    },
    credits: {
        enabled: false
    },
    legend: {
        enabled: false
    },
    xAxis: {
        type: 'category',
        labels: {
            enabled: true,
            rotation: -45,
            formatter: function () {
                const text = this.value,
                    formatted = text.length > 15 ? text.substring(0, 12) + '...' : text;

                return '<div title="' + text + '">' + formatted + '</div>';
            },
            useHTML: true
        },
    },
    yAxis: {
        title: {
            text: `<span class="text-light-valueColor">USD</span>`,
            useHTML: true
        },
        labels:{
            formatter: function () {
                const { number: value, suffix = '' } = numberFormatter(this.value)
                return `${numberFormat(value, 2, '.', ',')}${suffix}`;
            }
        }
    },
    lang: {
        thousandsSep: ','
    },
}

const CardBalancesChart = ({ module }) => {
    return (
        <div>
            <BarChart
                shouldFetch={true}
                chartProperties={chartProps}
                fetchMethod={getBalancesChartData}
                seriesKey="currenciesModels"
                otherOptions={otherOptions}
                hasFetchParams={true}
                fetchParams={[module]}
                shouldClear = {true}
            />
        </div>
    );
}

export default React.memo(CardBalancesChart)